import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

export default class HotSpot {
  scrollGrowTimelines: any;
  hotSpotWrapper: any;
  tl: gsap.core.Timeline;

  constructor() {
    this.hotSpotWrapper = document.querySelector('.hotspot__wrapper');
    if (!this.hotSpotWrapper) return;

    document.addEventListener("DOMContentLoaded", () => {
      this.initScrollTrigger();
      this.initHotSpots();
    })
  }

  initScrollTrigger() {
    let foreGroundImage = this.hotSpotWrapper.querySelector('.hotspot__foreground');

    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.hotSpotWrapper,
        start: 'top 50%',
      }
    });

    this.tl.fromTo(foreGroundImage, {
      opacity: 0
    }, {
      opacity: 1,
      duration: 2
    })
  }

  initHotSpots() {
    let hotSpots = this.hotSpotWrapper.querySelectorAll('.hotspot');

    hotSpots.forEach((hotSpot) => {
      hotSpot.addEventListener('click', () => {
        let spotID = hotSpot.dataset.id;
        let contentElement = this.hotSpotWrapper.querySelector(`#hotspot-content-${spotID}`)

        if (contentElement.classList.contains('active')) {
          contentElement.classList.remove('active');
        } else {
          let allContentElements = this.hotSpotWrapper.querySelectorAll('.hotspot__content.active')
          allContentElements.forEach((el) => { el.classList.remove('active') })
          contentElement.classList.add('active');
        }
      })
    });
  }
}
